/**
 * @license
 * Copyright (c) 2022 Handsoncode. All rights reserved.
 */
import { FunctionPlugin } from './plugin/FunctionPlugin';
export { FunctionPlugin };
